import { Button, message } from 'antd';
import { useState } from 'react';
import { sendAIRate } from 'services/api/my/ai';
import { AI_USAGE_REACTION } from 'utils/constants';
import styles from 'styles/components/aiFeedbackRate.module.scss';
import { DislikeOutlined, LikeOutlined } from '@ant-design/icons';
const AiFeedbackRate = ({ aiUsageId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleRate = (reaction) => {
    setIsLoading(true);
    sendAIRate({
      aiUsageId: aiUsageId,
      reaction: reaction,
    })
      .then(() => {
        message.success('Thank you for your feedback!');
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  return (
    <div className={styles.aiFeedbackRate}>
      <div>How was this feedback?</div>
      <Button
        size="small"
        type="link"
        onClick={() => {
          handleRate(AI_USAGE_REACTION.POSITIVE);
        }}
        className={styles.aiFeedbackRateButton}
        loading={isLoading}
        icon={<LikeOutlined />}
      ></Button>
      <Button
        type="link"
        onClick={() => {
          handleRate(AI_USAGE_REACTION.NEGATIVE);
        }}
        loading={isLoading}
        size="small"
        className={styles.aiFeedbackRateButton}
        icon={<DislikeOutlined />}
      ></Button>
    </div>
  );
};

export default AiFeedbackRate;
